<template>
    <span>
        <TooltipComp
            v-if="matrixStationRoleCell.SpeedKph > 0 && matrixStationRoleCell.SpeedKph > matrixStationRoleCell.MatrixConfig.SpeedLimitKph"
            :text="`${matrixStationRoleCell.SpeedKph.toString()} ${$tm('general.kph')}`"
        >
            <IconComp
                icon="fa-gauge-circle-minus"
                class="fs-5 text-indigo-600"
            />
        </TooltipComp>
    </span>
</template>
<script setup lang="ts">
import { IconComp, TooltipComp } from '@/components';
import type MatrixStationRoleCell from '../../classes/MatrixStationRoleCell';

const props = defineProps<{ matrixStationRoleCell: MatrixStationRoleCell }>();
</script>
